import { ModelCommon } from './ModelCommon'
import { Address, AddressType } from './commonAttributeSets/Address'
import { UserAttributeDefs } from '../types/ModelTypes'
import { DefaultContactDetails, DefaultContactDetailsType } from './commonAttributeSets/DefaultContactDetails'

const typeName = 'Organization'

const { dwelling_number, ...AddressLess } = Address

export type OrganizationType = Partial<AddressType> & Partial<DefaultContactDetailsType>
class Organization extends ModelCommon implements OrganizationType {
  constructor(ob: any) {
    super(ob.type || typeName, ob)
  }

  city?: string | undefined
  country?: string | undefined
  dwelling_number?: string | undefined
  post_code?: string | undefined
  street_number?: string | undefined
  suburb?: string | undefined
  email?: string | undefined
  phoneNumber?: string | undefined
  /** @deprecated in favour of {@link Organization.phoneNumber | phoneNumber} */
  phone_number?: string | undefined

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      ...AddressLess,
      ...DefaultContactDetails,
    }
  }
}

export { Organization }
